import { ComponentPropsWithRef } from "react";

export const InactiveIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.30987 0.839303L11.146 2.67541C11.3155 2.84495 11.3149 3.11853 11.146 3.28745L8.43343 6L11.146 8.71255C11.3155 8.88208 11.3149 9.15566 11.146 9.32458L9.30987 11.1607C9.14094 11.3296 8.86736 11.3302 8.69783 11.1607L5.98528 8.44815L3.27273 11.1607C3.10381 11.3296 2.83023 11.3302 2.6607 11.1607L0.824586 9.32459C0.655664 9.15566 0.655664 8.88147 0.824586 8.71255L3.53713 6L0.824586 3.28745C0.655663 3.11853 0.655663 2.84434 0.824586 2.67541L2.6607 0.839303C2.82962 0.670381 3.10381 0.670381 3.27273 0.839303L5.98528 3.55185L8.69783 0.839303C8.86675 0.670381 9.14095 0.670381 9.30987 0.839303Z"
      fill="currentColor"
    />
  </svg>
);
